import {
  Box,
  HStack,
  List,
  ListItem,
  SimpleGrid,
  Stack,
  VStack,
} from "@chakra-ui/layout";
import {
  Avatar,
  Card,
  CardBody,
  Divider,
  Icon,
  Image,
  Text,
} from "@chakra-ui/react";
import { Trans, useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { BannerWithHeading } from "../../generic/layout/bannerWithHeading";
import { Heading } from "../../generic/layout/heading";
import { MaxWidthContainer } from "../../generic/layout/maxWidthContainer";
import { ServiceDetails, servicesList } from "./services-list";
import { ServiceCard } from "./ServiceCard";
import greenerArbitrationLogo from "./media/greenerArbitrationLogo.jpeg";
import { Header } from "../../generic/layout/header";
import { HeadingMedium } from "../../generic/layout/headingMedium";

import { EmployeeCard } from "../team/EmployeeCard";

import WajmaMangalImage from "../team/media/dr-wajma-mangal.png";
import { companyColors } from "../../global/companyColors";
import { BsInfoSquareFill } from "react-icons/bs";
import { useEffect, useState } from "react";
import { CompanyAddress } from "../../generic/CompanyAddress";
import { GetInTouch } from "../contact/getInTouch";

export function ServicesDetails({}: {}) {
  const { languageCode, service } = useParams();
  const { t } = useTranslation();

  const [serviceDetails, setServiceDetails] = useState<
    ServiceDetails | undefined
  >(undefined);

  useEffect(() => {
    const details = servicesList.find((s) => s.service === service);
    setServiceDetails(details);
  }, [service]);

  return (
    <VStack spacing={0}>
      <BannerWithHeading bgUrl="/media/bg.jpg" headingText={t("services")} />

      <Box py={8}>
        <MaxWidthContainer>
          <HeadingMedium>
            {t("services." + service + ".title", { ns: "contentServices" })}
          </HeadingMedium>

          <Stack
            spacing={8}
            direction={{ base: "column", md: "row" }}
            alignItems={"flex-start"}
          >
            <Box>
              <Trans
                i18nKey={"services." + service + ".text"}
                ns="contentServices"
                parent={null}
                components={{
                  ul: <List styleType="disc" pl={6} spacing={1} />,
                  li: <ListItem />,
                }}
              ></Trans>
            </Box>
            {service == "dubai-desk" && (
              <>
                <Card
                  borderLeftColor={companyColors.blue[600]}
                  borderLeftWidth={4}
                  bg={companyColors.blue[200]}
                >
                  <CardBody>
                    <HStack spacing={3} alignItems={"flex-start"}>
                      <Icon
                        as={BsInfoSquareFill}
                        color={companyColors.blue[1000]}
                        mt="4px"
                        boxSize="24px"
                      />

                      <Text color={companyColors.blue[1000]}>
                        {t("services." + service + ".extra", {
                          ns: "contentServices",
                        })}
                      </Text>
                    </HStack>
                  </CardBody>
                </Card>
              </>
            )}
          </Stack>

          <Stack
            spacing={8}
            direction={{ base: "column", md: "row" }}
            alignItems={"flex-start"}
          >
            <Box>
              <HeadingMedium mt={12}>
                {t("yourContactPersons", { ns: "contentServices" })}
              </HeadingMedium>
              <Box display={"flex"}>
                <Stack spacing={8} direction={{ base: "column", md: "row" }}>
                  {serviceDetails?.contactPersons.map((person) => (
                    <EmployeeCard key={person.slug} employee={person} />
                  ))}

                  <GetInTouch variant="detailed" />
                </Stack>
              </Box>
            </Box>
            <Box></Box>
          </Stack>

          <Box>
            <HeadingMedium mt={12}>
              {t("more", { ns: "contentServices" })}
            </HeadingMedium>
            <SimpleGrid
              spacing={4}
              templateColumns="repeat(auto-fill, minmax(350px, 1fr))"
            >
              {servicesList.map((serviceItem) => {
                return (
                  //serviceItem !== service?.toString() &&
                  <ServiceCard
                    key={serviceItem.service}
                    service={serviceItem.service}
                    color={serviceItem.color}
                    isSmall={true}
                  />
                );
              })}
            </SimpleGrid>
          </Box>
        </MaxWidthContainer>
      </Box>
    </VStack>
  );
}
